import React from 'react'

import Button from '../../../components/Button/Button'
import ComboInput from '../../../components/ComboInput'
import Modal from '../../../components/Modal/Modal'

function LandskampMatchModal({
  isOpen,
  onClose,
  form,
  setForm,
  competitionOptions,
  teamOptions,
  venueOptions,
  cityOptions,
  onHomeTeamChange,
  onVenueChange,
  onCityChange,
  onSubmit,
  saving,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={form.id ? 'Redigér kamp' : 'Ny kamp'}
      size="medium"
      className="landskamp-admin-modal"
    >
      <div className="landskamp-admin-form">
        <label className="landskamp-admin-field">
          <div className="landskamp-admin-label">Kickoff</div>
          <input
            className="landskamp-admin-input"
            type="datetime-local"
            value={form.kickoffLocal}
            onChange={(e) => setForm((p) => ({ ...p, kickoffLocal: e.target.value }))}
          />
        </label>

        <label className="landskamp-admin-field">
          <div className="landskamp-admin-label">Turnering</div>
          <ComboInput
            id="competition"
            value={form.competition}
            options={competitionOptions}
            placeholder="Vælg turnering"
            ariaLabel="Turnering"
            onChange={(v) => setForm((p) => ({ ...p, competition: v }))}
          />
        </label>

        <div className="landskamp-admin-row">
          <label className="landskamp-admin-field">
            <div className="landskamp-admin-label">Hjemmehold</div>
            <ComboInput
              id="homeTeam"
              value={form.homeTeam}
              options={teamOptions}
              placeholder="Vælg/skriv hold"
              ariaLabel="Hjemmehold"
              onChange={onHomeTeamChange}
            />
          </label>
          <label className="landskamp-admin-field">
            <div className="landskamp-admin-label">Udehold</div>
            <ComboInput
              id="awayTeam"
              value={form.awayTeam}
              options={teamOptions}
              placeholder="Vælg/skriv hold"
              ariaLabel="Udehold"
              onChange={(v) => setForm((p) => ({ ...p, awayTeam: v }))}
            />
          </label>
        </div>

        <div className="landskamp-admin-row">
          <label className="landskamp-admin-field">
            <div className="landskamp-admin-label">Stadion</div>
            <ComboInput
              id="venue"
              value={form.venue}
              options={venueOptions}
              placeholder="Vælg/skriv stadion"
              ariaLabel="Stadion"
              onChange={onVenueChange}
            />
          </label>
          <label className="landskamp-admin-field">
            <div className="landskamp-admin-label">By</div>
            <ComboInput
              id="city"
              value={form.city}
              options={cityOptions}
              placeholder="Vælg/skriv by"
              ariaLabel="By"
              onChange={onCityChange}
            />
          </label>
        </div>

        <div className="landskamp-admin-row">
          <label className="landskamp-admin-field">
            <div className="landskamp-admin-label">Hjemme mål</div>
            <input
              className="landskamp-admin-input"
              type="number"
              min={0}
              value={form.homeScore}
              onChange={(e) => setForm((p) => ({ ...p, homeScore: e.target.value }))}
            />
          </label>
          <label className="landskamp-admin-field">
            <div className="landskamp-admin-label">Ude mål</div>
            <input
              className="landskamp-admin-input"
              type="number"
              min={0}
              value={form.awayScore}
              onChange={(e) => setForm((p) => ({ ...p, awayScore: e.target.value }))}
            />
          </label>
        </div>

        <div className="landskamp-admin-form__actions">
          <Button title="Annuller" variant="outlined" color="danger" onClick={onClose} />
          <Button title="Gem" color="confirmation" onClick={onSubmit} loading={saving} loadingText="Gemmer..." />
        </div>
      </div>
    </Modal>
  )
}

export default LandskampMatchModal
